import config from '@/config';
import {ApiBase} from '@/api/common';

const NO_UPLOAD_FIELDS = [
    'state',
];

export default class SentenceLink extends ApiBase<SentenceLink> {
    public static readonly SLUG: string = 'exercise-sentence-link';
    private static readonly URL_BASE: string = config.API_ROOT + '/exercise-sentence-link/';
    
    // Initializing these fields (even with undefined)
    // is necessary, so hasOwnAttribute can find them.
    public start_index?: number = undefined;
    public end_index?: number = undefined;
    public lesson?: number = undefined;
    public exercise?: number = undefined;
    public parent_id?: number = undefined;
    public parent_model?: string = undefined;
    
    // currently unused
    public spreadsheet?: string = undefined;
    
    // used to know if the hint is being created, was updated or is saved
    public state?: string = 'created';
    
    public constructor() {
        super({
            urlBase: SentenceLink.URL_BASE,
            filteredFields: NO_UPLOAD_FIELDS,
        });
    }
    
    public assign(response: any): SentenceLink {
        super.assign(response);
        this.state = 'unchanged';
        return this;
    }
}
